import { render, staticRenderFns } from "./AddressBuilderDialog.vue?vue&type=template&id=87061fa2&scoped=true"
import script from "./AddressBuilderDialog.vue?vue&type=script&lang=js"
export * from "./AddressBuilderDialog.vue?vue&type=script&lang=js"
import style0 from "./AddressBuilderDialog.vue?vue&type=style&index=0&id=87061fa2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87061fa2",
  null
  
)

export default component.exports